import ToastHighLighter from '@/lib/ToastHighLighter';

export const BackToTopCode = () => {
  const language = 'js';
  const codeString = `
  // Back-To-Top
  // Javascript: jQuery
  
  var back_to_top_button = ['<a href="#top" class="back-to-top"></a>'].join('');
  $('body').append(back_to_top_button);

  $(function () {
    $(window).scroll(function () {
      if ($(this).scrollTop() > 100) {
        $('.back-to-top').css({
          opacity: 0.4,
        });
      } else {
        $('.back-to-top').css({
          opacity: 0,
        });
      }
    });

    $('.back-to-top').click(function () {
      $('body,html').animate(
        {
          scrollTop: 0,
        },
        500
      );
      return false;
    });
  });

  `;

  return (
    <>
      <ToastHighLighter
        name={'backtotop'}
        codeString={codeString}
        language={language}
        show={true}
      />
    </>
  );
};
